module.exports = __webpack_public_path__ + "img/vmVirtual_89x69.38418b51.svg";